import {UseQueryResult, useQuery} from 'react-query';

import {
  ApiSeasonalVolumeResponse,
  SeasonalVolumeForecastQuery,
  fetchSeasonalVolumeForecasts,
} from 'src/lib/api/series';

export default function useSeasonalVolumeForecasts(
  query: SeasonalVolumeForecastQuery,
  isStaging: boolean
): UseQueryResult<ApiSeasonalVolumeResponse, Error | null> {
  return useQuery(
    ['seasonalVolumeForecast', query],
    () => {
      return fetchSeasonalVolumeForecasts(query, isStaging);
    },
    {retry: false, refetchOnWindowFocus: false, refetchOnReconnect: false}
  );
}
